export const notifications = {
  "Welcome, you are now connected.": {
    en: "Welcome, you are now connected.",
    tr: "Hoş geldin, bağlandın.",
    de: "Willkommen, Sie sind jetzt verbunden.",
    fr: "Bienvenue, vous êtes maintenant connecté.",
  },
  "Are you sure you want to leave the game?": {
    en: "Are you sure you want to leave the game?",
    tr: "Oyundan ayrılmak istediğinden emin misin?",
    de: "Bist du sicher, dass du das Spiel verlassen willst?",
    fr: "Voulez-vous vraiment quitter le jeu?",
  },
  "SkrablBot has exchanged his tiles.": {
    en: "SkrablBot has exchanged his tiles.",
    tr: "SkrablBot harf taşlarını değiştirdi.",
    de: "SkrablBot hat seine Buchstabensteine ausgetauscht",
    fr: "SkrablBot a échangé ses tuiles.",
  },
  "SkrablBot has decided to pass.": {
    en: "SkrablBot has decided to pass.",
    tr: "SkrablBot pas geçmeye karar verdi.",
    de: "SkrablBot hat beschlossen zu bestehen.",
    fr: "SkrablBot a décidé de passer.",
  },
  "This will be the sixth consecutive pass, and will end the game!  Are you sure you want to pass?": {
    en:
      "This will be the sixth consecutive pass, and will end the game!  Are you sure you want to pass?",
    tr:
      "Bu art arda altıncı pas olacak ve oyunu bitirecek! Pas geçmek istediğinden emin misin?",
    de:
      "Dies ist der sechste Durchgang in Folge und beendet das Spiel! Bist du sicher, dass du bestehen willst?",
    fr:
      "Ce sera la sixième passe consécutive et mettra fin au jeu! Êtes-vous sûr de vouloir réussir?",
  },
  "Are you sure you want to pass?": {
    en: "Are you sure you want to pass?",
    tr: "Pas geçmek istediğinden emin misin?",
    de: "Bist du sicher, dass du bestehen willst?",
    fr: "Etes-vous sûr que vous voulez passer?",
  },
  "Are you sure you want to resign?": {
    en: "Are you sure you want to resign?",
    tr: "Teslim olmak istediğinden emin misin?",
    de: "Bist du sicher, dass du aufgeben willst?",
    fr: "Êtes-vous sûr de vouloir abandonner?",
  },
  "The following word was not found in the dictionary:": {
    en: "The following word was not found in the dictionary:",
    tr: "Bu kelime sözlükte bulunamadı:",
    de: "Das folgende Wort wurde im Wörterbuch nicht gefunden:",
    fr: "Le mot suivant n'a pas été trouvé dans le dictionnaire:",
  },
  "The first word on the board must use the centre square.": {
    en: "The first word on the board must use the centre square.",
    tr: "Tahtadaki ilk kelime orta kareyi kullanmalıdır.",
    de: "Das erste Wort auf der Tafel muss das mittlere Quadrat verwenden.",
    fr: "Le premier mot du tableau doit utiliser le carré central.",
  },
  "The move is not valid.": {
    en: "The move is not valid.",
    tr: "Hamle geçerli değil.",
    de: "Der Umzug ist ungültig.",
    fr: "Le mouvement n'est pas valide.",
  },
  "wins by default!": {
    en: "wins by default!",
    tr: "hükmen kazandı.",
    de: "gewinnt standardmäßig!",
    fr: "gagne par défaut!",
  },
  "ran out of time!": {
    en: "ran out of time!",
    tr: "zamanını kaybetti!",
    de: "lief die Zeit davon!",
    fr: "manqua de temps!",
  },
  "wins!": {
    en: "wins!",
    tr: "kazandı!",
    de: "gewinnt!",
    fr: "gagne!",
  },
  "It's a draw!": {
    en: "It's a draw!",
    tr: "Bu bir beraberlik!",
    de: "Es ist eine Zeichnung!",
    fr: "C'est un tirage au sort!",
  },
};
